import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import { formatDate, StatusBadge } from "./common";

function SortButton({ active, children, direction, onClick }) {
  return (
    <button
      type="button"
      className={`fera-sort-button ${active ? "is-active" : ""}`}
      onClick={onClick}
    >
      {children}
      {active ? <span aria-hidden="true">{direction === "asc" ? " ↑" : " ↓"}</span> : null}
      {active ? <span className="visually-hidden"> sorted {direction === "asc" ? "ascending" : "descending"}</span> : null}
    </button>
  );
}

export default function ResultTable({
  items,
  surveyId = null,
  sort = "lastSavedAt",
  direction = "desc",
  onSort,
}) {
  const sortHeader = (key, label) => (
    <SortButton
      active={sort === key}
      direction={direction}
      onClick={() => onSort?.(key)}
    >
      {label}
    </SortButton>
  );

  return (
    <div className="table-responsive">
      <Table className="fera-table fera-result-table" hover>
        <thead>
          <tr>
            {!surveyId ? <th>Survey</th> : null}
            <th>{sortHeader("respondent", "Respondent")}</th>
            <th>Source</th>
            <th>Status</th>
            <th>{sortHeader("startedAt", "Started")}</th>
            <th>{sortHeader("lastSavedAt", "Last saved")}</th>
            <th>{sortHeader("submittedAt", "Submitted")}</th>
            <th>Version</th>
            <th><span className="visually-hidden">Actions</span></th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => {
            const ownerSurveyId = surveyId || item.survey?.id;
            return (
              <tr key={item.id}>
                {!surveyId ? (
                  <td>
                    <Link className="fera-table-title" to={`/dashboard/surveys/${ownerSurveyId}/results`}>
                      {item.survey?.name || "Survey"}
                    </Link>
                  </td>
                ) : null}
                <td>
                  <span className="fera-table-title">{item.respondent.displayName}</span>
                  {item.respondent.verifiedEmail
                    && item.respondent.verifiedEmail !== item.respondent.displayName
                    ? <small>{item.respondent.verifiedEmail}</small>
                    : null}
                </td>
                <td>{item.source.label}</td>
                <td><StatusBadge status={item.status} /></td>
                <td>{formatDate(item.startedAt)}</td>
                <td>{formatDate(item.lastSavedAt)}</td>
                <td>{item.submittedAt ? formatDate(item.submittedAt) : "\u2014"}</td>
                <td>v{item.version}</td>
                <td className="text-end">
                  <Button
                    as={Link}
                    size="sm"
                    variant="outline-primary"
                    to={`/dashboard/surveys/${ownerSurveyId}/results/${item.id}`}
                  >
                    View report
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export { SortButton };
